import React from 'react'
import styled from 'styled-components'

const Styles = {
    Card: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: ${({flex}) => flex};
    width: ${({width}) => width };
    height: ${({height}) => height};
    padding: ${({padding}) => padding}; 
    margin: ${({margin}) => margin};
    border-radius: ${({theme}) => theme.borderRadius};
    box-shadow: 0 3px 15px ${({ shadowColor }) => shadowColor}40;
    background-color: ${({ bgColor }) => bgColor};
    `,
}

const FloatCard = ({flex= '0 1 auto', shadowColor = '#000000', bgColor='#ffffff',padding='1rem 2rem', width = '100%', margin='0', height='auto', children}) => {
  return (
   <Styles.Card flex={flex} width={width} shadowColor={shadowColor} bgColor={bgColor} padding={padding} margin={margin} height={height}
   > 
       {children}
   </Styles.Card>
  )
}

export default FloatCard
